export default __webpack_public_path__ + "static/media/coffee.64de31c1.svg";